import React, { useRef, useEffect } from 'react';
import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  gridItem: {
    width: '100%',
    height: 'auto', // Set initial height to auto
  },
}));

const RectangularGrid = (props) => {
  const classes = useStyles();
  const gridItemRef = useRef(null);

  useEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const { width } = entry.contentRect;
        gridItemRef.current.style.height = `${width * (props.ratio || 1)}px`; // Set height equal to width
      }
    });

    resizeObserver.observe(gridItemRef.current);

    return () => {
      resizeObserver.unobserve(gridItemRef.current);
    };
  }, [props]);

  return (
    <Grid item className={classes.gridItem} ref={gridItemRef} {...props}>
      {/* Grid item content */}
    </Grid>
  );
};

export default RectangularGrid;
